<template>
  <div class="hp-sticky-search hp-show-mobile" :class="{ 'hp-sticky-search--visible': visible }">
    <div class="container">
      <HomeSearchBar
        :filter.sync="localFilter"
        :course-options="courseOptions"
        :location-options="locationOptions"
        variant="compact"
        id-prefix="jl-sticky"
        submit-label="Search"
        :show-labels="false"
        @search="$emit('search', $event)"
      />
    </div>
  </div>
</template>

<script>
import HomeSearchBar from '@/components/home/HomeSearchBar.vue';

export default {
  name: 'JobsListStickySearch',
  components: { HomeSearchBar },
  props: {
    visible: { type: Boolean, default: false },
    filter: { type: Object, required: true },
    courseOptions: { type: Array, default: () => [] },
    locationOptions: { type: Array, default: () => [] },
  },
  computed: {
    localFilter: {
      get() { return this.filter; },
      set(val) { this.$emit('update:filter', val); },
    },
  },
};
</script>
